import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Button } from "../common";

const Accordion = (props) => {
  const { parent, children } = props;

  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <div
      onMouseEnter={() => {
        !open && setOpen(true);
      }}
      onMouseLeave={() => open && setOpen(false)}
    >
      <Button
        handler={()=>setOpen(!open)}
        classes={`flex py-2.5 pr-4 pl-3 w-full hover:bg-transparent font-bold text-left hover:text-white ${
          open
            ? "border-b-2 border-greenWebsite text-greenWebsite"
            : "border-b-2 border-transparent text-white"
        }`}
      >
        <span className="mr-2 hover:text-greenWebsite">{parent}</span>
        <svg
          data-accordion-icon
          className={`w-4 h-4 ${open ? "rotate-180" : "rotate-0"} shrink-0`}
          fill={open ? "#39b3b3" : "#fff"}
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </Button>
      <ul
        className={`${
          !open ? "hidden opacity-100" : " opacity-100"
        } transition-opacity text-left tablet:py-3 tablet:pl-5 w-36 tablet:w-full tablet:bg-transparent bg-white border-0 absolute tablet:relative tablet:origin-top-right tablet:right-0 font-bold`}
      >
        {children.map((item) => (
          <li>
            <Button
              handler={() => navigate(item.link, { replace: true })}
              text={item.menu}
              classes={`block w-full py-3 pr-4 pl-3 ${
                location.pathname === item.link
                  ? "border-b-2 border-white"
                  : "bg-transparent"
              } rounded tablet:text-darkBlue text-darkBlue text-left hover:text-greenWebsite`}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

Accordion.propTypes = {
  parent: PropTypes.string,
  children: PropTypes.any,
};

export default Accordion;
